import getGenomeById from './getGenomeById';

// eslint-disable-next-line import/prefer-default-export
export { getGenomeById };